import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import { useFormContext, useWatch } from 'react-hook-form';
import { HookFormSelectionList } from 'components/hookForm';
import { isLeafNode } from 'utils/elevion';
import { renderItemOrList, } from '../../renderItemOrList';
export const CustomAttributeLeafValueField = ({ parentName, fieldName, customFields, disabled, }) => {
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
    const { control } = useFormContext();
    const node = useWatch({
        control,
        name: parentName,
    });
    const mapCustomFieldOptions = (option) => {
        if (option.options && option.options.length > 0) {
            const value = option.value;
            const isSelected = isLeafNode(node) &&
                Array.isArray(node.value) &&
                node.value.includes(value);
            if (isSelected) {
                return {
                    value: option.value,
                    title: option.label,
                };
            }
            return Object.assign({ title: option.label, items: option.options.map(mapCustomFieldOptions) }, (option.value && { value: option.value }));
        }
        return {
            value: option.value,
            title: option.label,
        };
    };
    const customField = customFields.find((field) => isLeafNode(node) && node.field === `custom__${field.identifier}`) || null;
    const customFieldOptions = customField && 'options' in customField ? customField.options : [];
    const selectItems = customFieldOptions
        .map((option) => mapCustomFieldOptions(option))
        .filter((item) => item.value);
    return (_jsx(HookFormSelectionList, Object.assign({ name: fieldName, control: control, noLabel: true, noAlert: true, disabled: disabled, componentProps: {
            multiple: true,
            getItemTitleByValue: (value) => {
                return (_jsx(Text.Paragraph, { children: getAttributeLabelByValue(value, customFieldOptions) }));
            },
            placeholder: 'Select a value',
            dropdownProps: {
                style: {
                    width: 'auto',
                    minWidth: '240px',
                },
            },
        } }, { children: selectItems.map(renderItemOrList) })));
};
/** Creates a proper label containing path based on selected value. */
function getAttributeLabelByValue(value, options) {
    const option = options.find((option) => option.value === value);
    if (option) {
        return option.label;
    }
    for (const option of options) {
        if (option.options) {
            const label = getAttributeLabelByValue(value, option.options);
            if (label) {
                return `${option.label} / ${label}`;
            }
        }
    }
    return null;
}
